searchHandler = {
    $panelSearchBlog = $('.filter-posts'),
    $html = $('html'),
    $pagingItem = $('.paging-item'),
    $searchedItem = $('.searched-item'),
    $searchedItemContainer = $('.searched-item-container'),

    init = function(){
        var self = this;

        this.$panelSearchBlog.each(function(){
            var $panel = $(this); 
            var id = $panel.data('id');
            var $textSearched = $panel.find('.text-searched');

            $panel.find('.input-search').on('keypress',function(e) {
                if(e.which == 13) {
                    $panel.find('.button-search').click();
                }
            });
             
            $panel.find('.button-search').on('click', function(){
                var $button = $(this);
                var query = $button.data('query');
                var search = $button.prev().val();
        
                $.ajax({
                    type: 'post',
                    url: myAjax.ajax_url,
                    data: {
                        action: 'search_blog_post',
                        query: query,
                        search: search.trim()
                    },

                    beforeSend: function(){
                        $textSearched.html('');
                        self.$html.addClass('loading');
                    },
                    
                    success: function(response) {
                        if (response['status'] == 'ok') {
                            $panel.next().remove();
                            $panel.parent().append(response['html']);       

                            var count = $panel.next().find('.item-data').length;

                            if (search.trim() !== '') {
                                $textSearched.html('Showing '+count+' Results for “'+search+'”');
                            }             
                        }
                    },

                    complete: function(){
                        $container = $('body').find('.panel-posts-container.data-container');
                        filterHandler.setPaging($container);
                        $(document).foundation();
                        self.$html.removeClass('loading');
                    }
                    
                });
            });

        })

        this.$pagingItem.on('click', function(){
            self.$html.animate({scrollTop: 0}, 'slow');

            var activePage = $(this).data('active-page');
            self.$searchedItem.removeClass('active');
            self.$pagingItem.removeClass('active');

            self.$searchedItemContainer.find('[data-page="'+activePage+'"]').addClass('active');
            $(this).addClass('active');
            
        });
        

    }
}